import { render } from "./X1.vue?vue&type=template&id=40686bc7"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/X1.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "40686bc7"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('40686bc7', __exports__)) {
    api.reload('40686bc7', __exports__)
  }
  
  module.hot.accept("./X1.vue?vue&type=template&id=40686bc7", () => {
    api.rerender('40686bc7', render)
  })

}


export default __exports__